import styled from "styled-components";

import { colors } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/MenuEditor/styles";

export const Head = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;
`;

export const CategoryTitle = styled.h2`
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: ${colors.textPrimary};
`;

export const Pill = styled.span<{ $tone: "neutral" | "warning" }>`
    padding: 4px 10px;
    border-radius: 22px;
    font-size: 12px;
    background: ${({ $tone }) =>
        $tone === "warning" ? colors.warningBg : "rgba(0,0,0,0.04)"};
    color: ${({ $tone }) => ($tone === "warning" ? "#8a6100" : colors.textSecondary)};
`;

export const Spacer = styled.div`
    flex: 1 1 auto;
`;

// Ниже 960 кнопка переезжает в полосу выбора категории — там она под большим пальцем,
// а строка заголовка на узком экране и без неё переполнена чипами.
export const SettingsButton = styled.div`
    flex: none;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: none;
    }
`;
